import { createSequence } from '@olivierpascal/helpers';
import { AssistChip, Skeleton, Stack, Text } from '@sixui/ui';
import { shapeTokens } from '@sixui/ui/themes/base/shape.stylex';
import { spacingTokens } from '@sixui/ui/themes/base/spacing.stylex';
import stylex from '@stylexjs/stylex';

import { ITableRowProps, Table } from '~/components/molecules/Table';
import { random } from '~/helpers/random';

const MAX_RECORDINGS = 3;
const RECORDING_WIDTH = 120;
const RECORDING_HEIGHT = Math.round(RECORDING_WIDTH / 1.8);

export type ILiveStreamListItemSkeleton = ITableRowProps;

const styles = stylex.create({
  recordings: {
    display: 'grid',
    gridTemplateColumns: `repeat(${MAX_RECORDINGS + 1}, min-content)`,
    gap: spacingTokens.padding$3,
  },
  recording: {
    borderRadius: shapeTokens.corner$xs,
    width: RECORDING_WIDTH,
    height: RECORDING_HEIGHT,
  },
});

export const LiveStreamListItemSkeleton: React.FC<
  ILiveStreamListItemSkeleton
> = (props) => (
  <Table.Row {...props}>
    <Stack as={Table.Body} gap={2}>
      <Stack gap={1}>
        <Text
          as={Skeleton}
          variant="title"
          size="sm"
          length={{ min: 8, max: 64 }}
        />
        <Skeleton length={{ min: 8, max: 32 }} />
      </Stack>

      <div {...stylex.props(styles.recordings)}>
        {createSequence(random({ min: 1, max: MAX_RECORDINGS + 1 })).map(
          (index) => (
            <Skeleton key={index} sx={styles.recording}>
              XX
            </Skeleton>
          ),
        )}
      </div>
    </Stack>

    <Stack as={Table.Body} gap={1}>
      <Skeleton length={{ min: 8, max: 16 }}>
        <AssistChip />
      </Skeleton>
      <Text
        as={Skeleton}
        variant="body"
        size="sm"
        length={{ min: 8, max: 32 }}
      />
    </Stack>

    <Stack as={Table.Body} justify="end">
      <Skeleton length={8} />
    </Stack>
  </Table.Row>
);
